import React from "react";
import { withRouter } from "react-router-dom";
import { AzureAD, AuthenticationState } from "react-aad-msal";

import { authProvider } from "../authProvider";
import Layout from "./Layout";

const ThemeSelector = ({ store }) => {
  return (
    <AzureAD provider={authProvider} reduxStore={store} forceLogin>
      {({ authenticationState, accountInfo }) =>
        authenticationState === AuthenticationState.Authenticated ? (
          <Layout account={accountInfo.account} />
        ) : (
          <h1>Please log in</h1>
        )
      }
    </AzureAD>
  );
};

export default withRouter(ThemeSelector);
